import { render, staticRenderFns } from "./GenerarCupon.vue?vue&type=template&id=b101d426&"
import script from "./GenerarCupon.vue?vue&type=script&lang=js&"
export * from "./GenerarCupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports